<!-- Radiance header when feature enabled -->
<ng-container *ngIf="!legacyNavbarEnabled">
  
  <rad-subscription-banner
    *ngIf="subscriptionBannerEnabled"
    class="rad-theme--light"
    [attr.domain]="platformDomain"
    [attr.environment]="subscriptionBannerEnvironment"
    [attr.platform-base-url]="platformBaseUrl"
  ></rad-subscription-banner>

  <rad-header-navigation
    #radHeaderNav
    [appShadowStyle]="headerNavShadowStyles"
    class="rad-theme--light"
    
    [attr.domain]="platformDomain"
    [attr.product-title]="appTitle"
    (titleClicked)="titleClicked()"
    (workgroupChanged)="onRadWorkgroupChanged($event)"
    (authFailure)="onRadAuthFailure($event)"
    (skipLinkClicked)="onSkipLinkClicked()"
    [attr.client-id]="clientId"
    [attr.region]="regionCode"
    [attr.skip-link]="'main-content'"
	  [attr.platform-api-url]="platformBaseUrl"
    cache="false"
    products-enabled
    workgroups-enabled
    personal-workgroup-enabled
    default-menu-view="workgroups"
	  [attr.app-whitelist-url]="appWhitelistUrl"
  >
  <span slot="nav-icons" style="gap: 10px;">
      <!-- Search icon -->
      <rad-icon-button 
        id="rad-search-btn"
        class="rad-theme--light" 
        variant="icon" 
        appearance="header" 
        size="large"
        icon-name="search"
        aria-label="Search"
        (click)="toggleRadSearch()"
        data-testid="nav-search-btn"
      ></rad-icon-button>

      <!-- Notifications bell icon and dropdown -->
      <div #radNotificationsDropdownRef class="rad-notifications-wrapper">
        <rad-icon-button 
          id="rad-notifications-btn"
          class="rad-theme--light" 
          variant="icon" 
          appearance="header" 
          size="large"
          icon-name="notificationBell"
          aria-label="Notifications"
          (click)="toggleNotificationsDropdown()"
          data-testid="nav-notifications-btn"
        >
        </rad-icon-button>

        <lib-dropdown
          #radNotificationsDropdownMenu
          [reference]="radNotificationsDropdownRef"
          [config]="radNotificationsDropdownConfig"
        >
          <div class="drop-down notifications-menu">
            <div class="notifications-menu__title">Notifications</div>

            <div class="notifications-menu__content">
              <!-- Loading skeletons (shown while loading, outside ngFor) -->
              <ng-container *ngIf="alertNotificationsLoading$ | async">
                <div class="notifications-menu__content__item" *ngFor="let i of [1, 2, 3]">
                  <div class="notifications-menu__card__loader">
                    <lib-skeleton
                      class="notifications-menu__card__loader-title"
                      type="text"
                      [lines]="1"
                    ></lib-skeleton>
                    <lib-skeleton
                      class="notifications-menu__card__loader-description"
                      type="text"
                      [lines]="1"
                    ></lib-skeleton>
                  </div>
                </div>
              </ng-container>

              <!-- Content shown when not loading -->
              <ng-container *ngIf="!(alertNotificationsLoading$ | async)">
                <!-- No notifications message -->
                <div
                  class="notifications-menu__content__item"
                  *ngIf="alertNotificationsMessage"
                >
                  <h5
                    class="notifications-menu__card__description"
                    [title]="alertNotificationsMessage"
                    data-cy="notification-alertNotificationsMessage"
                  >
                    {{ alertNotificationsMessage }}
                  </h5>
                </div>

                <!-- Notification items -->
                <div
                  class="notifications-menu__content__item"
                  *ngFor="let notification of (alertNotifications$ | async)?.currentUserAlertNotifications?.alertCards; let i = index"
                >
                  <div class="notifications-menu__card">
                    <div class="notifications-menu__card__content">
                      <h5
                        class="notifications-menu__card__title"
                        [title]="notification.title"
                        data-cy="notification-title"
                      >
                        {{ notification.title }}
                      </h5>
                      <h5
                        class="notifications-menu__card__date"
                        [title]="notification.date"
                        data-cy="notification-date"
                      >
                        {{ notification.date }}
                      </h5>
                      <h5
                        class="notifications-menu__card__description"
                        [title]="notification.description"
                        data-cy="notification-description"
                      >
                        {{ notification.description }}.
                        <a
                          *ngIf="notification.route && notification.route !== '' && notification.route !== '#'"
                          href="javascript:void(0)"
                          (click)="navigateToNotification(notification.route)"
                          class="notifications-menu__card__link"
                          data-cy="notification-card-link"
                        >
                          {{ notification.name }}
                        </a>
                      </h5>
                    </div>

                    <!-- Dismiss button -->
                    <div class="notifications-menu__card__actions">
                      <button
                        type="button"
                        *ngIf="notification.dismissible"
                        (click)="removeRadNotification(notification, i)"
                        aria-label="Close"
                        class="notifications-menu__card__actions-close-btn"
                      >
                        <svg
                          class="notifications-menu__card__actions-close-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z"
                            fill="#656066"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </lib-dropdown>
      </div>

      <!-- Help icon and dropdown -->
      <div #radHelpDropdownRef class="rad-help-wrapper">
        <!-- WalkMe launcher 406335 ("V8 PAGES Invisible Help Coverup") binds via the jQuery
             selector `.walkeme-trigger--panel.btn--icon.btn--icon--help-circle` from the legacy
             lib-universal-navbar help button. WalkMe ignores its configured Host, so all three
             classes (including the misspelled `walkeme`) are required for the help menu to overlay
             this Radiance icon. Removing any of them silently breaks the WalkMe help launcher. -->
        <rad-icon-button 
          id="rad-help-btn"
          class="rad-theme--light walkeme-trigger--panel btn--icon btn--icon--help-circle" 
          variant="icon" 
          appearance="header" 
          size="large"
          icon-name="questionCircle"
          aria-label="Help"
          (click)="toggleHelpDropdown($event)"
          data-testid="nav-help-btn"
        >
        </rad-icon-button>

        <lib-dropdown
          #radHelpDropdownMenu
          [reference]="radHelpDropdownRef"
          [config]="radHelpDropdownConfig"
        >
          <div class="drop-down help-menu">
            <div class="help-menu__item" (click)="helpAction($event)" data-testid="nav-help-docs-link">
              Help documentation
            </div>
          </div>
        </lib-dropdown>
      </div>

      <!-- Profile dropdown wrapper -->
      <div #radProfileDropdownRef class="rad-profile-wrapper">
        <!-- User initials button (profile menu trigger) -->
        <rad-icon-button 
          id="rad-profile-menu-trigger"
          class="rad-theme--light" 
          variant="icon" 
          appearance="header" 
          size="large"
          *ngIf="currentUser$ | async as currentUser"
          (click)="openRadProfileMenu($event)"
        >
          <span style="display: flex; align-items: center; justify-content: center; color: white; border: 1px solid white; border-radius: 50%; width: 24px; height: 24px; font-size: 10px; font-weight: 500;">{{ userInitials }}</span>
        </rad-icon-button>

        <!-- Profile dropdown menu using lib-dropdown -->
        <lib-dropdown
          #radProfileDropdownMenu
          [reference]="radProfileDropdownRef"
          [config]="radProfileDropdownConfig"
        >
          <div class="drop-down profile-menu">
            <!-- User info header (non-interactive) -->
            <div class="profile-menu__header">
              <div class="profile-menu__avatar">{{ userInitials }}</div>
              <div class="profile-menu__info">
                <span class="profile-menu__name">{{ userName }}</span>
                <span class="profile-menu__email">{{ userEmail }}</span>
              </div>
            </div>
            
            <!-- Admin Console option (conditional) -->
            <a 
              *ngIf="showAdminConsoleLink" 
              class="profile-menu__item" 
              [href]="adminConsoleUrl" 
              target="_blank"
            >Admin Console</a>
            
            <!-- Terms option -->
            <a
              class="profile-menu__item"
              [href]="termsUrl"
              target="_blank"
              rel="noopener noreferrer"
            >Terms</a>
            
            <!-- Sign out option -->
            <div class="profile-menu__item" (click)="logOut()" data-testid="nav-sign-out-btn">Sign out</div>
          </div>
        </lib-dropdown>
      </div>
    </span>
  </rad-header-navigation>
</ng-container>

<ng-container *ngIf="legacyNavbarEnabled">
  <lib-universal-navbar
    (workGroupOpen)="log($event)"
    (searchOpen)="searchAction($event)"
    [searchWidgetConfig]="searchWidgetParameters"
    (onSelectSearchAction)="onSelectAction($event)"
    (notificationsOpen)="notificationsAction($event)"
    (helpOpen)="helpAction($event)"
    (trashOpen)="trashAction($event)"
    (workGroupSelected)="switchUserContext($event)"
    (applicationsOpen)="log($event)"
    (signOutClicked)="logOut($event)"
    [logoUrl]="logoUrl"
    [title]="navBarTitle"
    [titleLink]="titleLink"
    [logoLinkNewWindow]="logoLinkNewWindow"
    [titleLinkNewWindow]="titleLinkNewWindow"
    [applicationLinkBottom]="navBarApplicationLinkBottom"
    [profileLinks]="navBarProfileLinks"
    [links]="navBarLinks"
    [showNotifications]="true"
    (notificationDeleted)="deleteUserAlertNotification($event)"
    [trashBadge]="trashBadge"
    [transparent]="transparent"
    [userAlertNotificationService]="navBarUserAlertNotificationService"
    [userApplicationsService]="navBarUserApplicationsService"
    [userService]="navBarUserService"
    [userWorkgroupService]="navBarUserWorkgroupService"
  ></lib-universal-navbar>
</ng-container>

<!-- Todo : move this error div to a separate component and open the modal dynamically. 
	For now, it is in the template-->
<div #subscriptionErrorModalDiv>
	<ngx-smart-modal #subscriptionErrorModal identifier="errorModal" title="An Active Sequence Hub Subscription is Required"
		[showCloseButton]="true" closeButtonText="Close" [showConfirmButton]="false" [escapable]="true"
		[dismissible]="true">
		<app-subscription-error-modal-body></app-subscription-error-modal-body>
	</ngx-smart-modal>
</div>

<!-- used for walkme only, always hidden: this should only be added to the DOM when the archive code feature is enabled. -->
<input type="hidden" value="archive-enabled" *ngIf="archiveEnabled" id="bs-toolbar-file-archive"/>

<!-- used for walkme only, always hidden: this should only be added to the DOM when the run zip code feature is enabled. -->
<input type="hidden" value="runzipping-enabled" *ngIf="runZippingEnabled" id="bs-toolbar-run-zip"/>

<!-- used for walkme only, always hidden: this should only be added to the DOM when user has Ica Subscription. -->
<input type="hidden" value="ica-subscription-active" *ngIf="userHasActiveIcaSubscription"  id="ica-subscription-active"/>
